import { render, staticRenderFns } from "./ListRegister.vue?vue&type=template&id=4c47810c&"
import script from "./ListRegister.vue?vue&type=script&lang=js&"
export * from "./ListRegister.vue?vue&type=script&lang=js&"
import style0 from "./ListRegister.vue?vue&type=style&index=0&id=4c47810c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports